import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState("");
  const [successAlert, setSuccessAlert] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (accessToken) {
      navigate("/dashboard");
    }
    window.scrollTo(0, 0);
  }, [navigate]);

  const loginUser = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorAlert("");
    setSuccessAlert("");

    var apiBaseURL = process.env.REACT_APP_API_BASE_URL;

    try {
      const config = {
        headers: {
          "x-strutspos-application": "user",
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-client-identifier": "web",
        },
      };

      const response = await axios.post(
        apiBaseURL + "/sessions",
        {
          email: username,
          password: password,
        },
        config
      );

      setIsLoading(false);
      if (response.data.user.id) {
        localStorage.setItem("strutspos_user_id", response.data.user.id);
        localStorage.setItem(
          "strutspos_access_token",
          response.headers["x-strutspos-token"]
        );
        localStorage.setItem("strutspos_user", response.data.user);

        var welcomeMessage = "Login successful. Redirecting to dashboard...";
        setSuccessAlert(welcomeMessage);
        setErrorAlert("");
        navigate("/dashboard");
      } else {
        setErrorAlert("Login failed.");
        setSuccessAlert("");
      }
    } catch (error) {
      setIsLoading(false);
      setErrorAlert("Login failed. Please check your credentials.");
      setSuccessAlert("");
    }
  };

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            {/* <Link to="/" className="auth-brand">
              <img src="/assets/logo.png" alt="Optimus" className="auth-logo" />
              <span>Optimus</span>
            </Link> */}
            <h1>Welcome back</h1>
            <p>Sign in to your account to continue</p>
          </div>

          <form onSubmit={loginUser} className="auth-form">
            <div className="form-group">
              <label>Email or Username</label>
              <input
                type="text"
                placeholder="Enter your email or username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span>Remember me</span>
              </label>
              {/* <Link to="/forgot-password" className="forgot-link">
                Forgot password?
              </Link> */}
            </div>

            <button
              type="submit"
              className={`btn-primary full-width ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Sign in"}
            </button>

            {errorAlert && (
              <div className="alert alert-error">{errorAlert}</div>
            )}

            {successAlert && (
              <div className="alert alert-success">{successAlert}</div>
            )}
          </form>

          {/* <div className="auth-footer">
            <p>
              Don't have an account? <Link to="/signup">Sign up</Link>
            </p>
          </div> */}
        </div>
      </div>

      <ModernFooter />
    </div>
  );
};

export default Login;
